export function isDesktopCloudBackend(): boolean {
  if (typeof window === "undefined" || window.desktopBridge === undefined) {
    return false;
  }

  const bootstrap = window.desktopBridge.getLocalEnvironmentBootstrap?.();
  return bootstrap?.primaryMode === "cloud";
}

/**
 * Redirect target for a protected route (e.g. `/_chat`) given the current auth
 * state, or `null` to proceed and render the route.
 *
 * Terminal states:
 * - authenticated → `null` (render the protected route)
 * - unauthenticated → `/login`
 */
export function resolveProtectedRouteRedirect(isAuthenticated: boolean): "/login" | null {
  if (isAuthenticated) {
    return null;
  }
  return "/login";
}

/**
 * Redirect target for the `/login` route given the current auth state, or
 * `null` to render the login surface.
 *
 * Terminal states:
 * - authenticated → `/` (the protected app shell)
 * - unauthenticated → `null` (render the login surface)
 */
export function resolveLoginRouteRedirect(isAuthenticated: boolean): "/" | null {
  if (isAuthenticated) {
    return "/";
  }
  return null;
}
